import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AlertV2, Button, EAlertV2Type, Modal } from '@feathr/components';

import * as styles from './SaveChangesModal.css';

interface ISaveChangesModalProps {
  opened: boolean;
  onClose: () => void;
  onSaveAndClose?: () => void;
}

function SaveChangesModal({
  opened: isModalOpen,
  onClose: closeModal,
  onSaveAndClose,
}: Readonly<ISaveChangesModalProps>): JSX.Element {
  const { t } = useTranslation();

  const handleSaveAndClose = (): void => {
    if (onSaveAndClose) {
      onSaveAndClose();
    }
    closeModal();
  };

  return (
    <Modal
      onClose={closeModal}
      opened={isModalOpen}
      rightActions={[
        <Button key={'back'} onClick={closeModal}>
          {t('Back')}
        </Button>,
        <Button key={'save-and-close'} onClick={handleSaveAndClose} type={'primary'}>
          {t('Save and close')}
        </Button>,
      ]}
      size={'default'}
      title={t('Save changes?')}
    >
      <AlertV2
        className={styles.warningAlert}
        description={t(
          'Changes to this geofilter set will impact all active campaigns that use this set. Ensure these changes are intentional, as they will be applied automatically across the following campaigns:',
        )}
        title={t('Warning')}
        type={EAlertV2Type.warning}
      />
    </Modal>
  );
}

export default SaveChangesModal;
